interface IErrorFeedbackProps {
  message: string;
}

const ErrorFeedback = (props: IErrorFeedbackProps) => {
  const { message } = props;

  return <p className="text-xs text-red-700 m-0 -ml-0.5 mt-0.5 flex">{message}</p>;
};

export default ErrorFeedback;
